import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import type { TabsProps } from "antd"
import { Tabs } from "antd"

import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import UiStore from "@src/app/uiStore"
import { SettingsAllowlistPage } from "@src/pages/settingsAllowList"
import { SettingsApiKeysPage } from "@src/pages/settingsApiKeys"
import { SettingsCallbackUrlPage } from "@src/pages/settingsCallbackUrl"
import { SettingsDomainPage } from "@src/pages/settingsDomain"
import { SettingsSecurityPage } from "@src/pages/settingsSecurity"
import { SettingsTeam } from "@src/pages/settingsTeam"
import { SettingsWhitelistPage } from "@src/pages/settingsWhitelist"
import { SettingsWhiteListIpPage } from "@src/pages/settingsWhiteListIp"
import { SettingsAutoConversionPage } from "../settingsAutoConversion"
import { SettingsBankDetailsPage } from "../settingsBankDetails"
import css from "./index.module.css"

enum SettingTab {
  AllowListPage = "al",
  ApiKeys = "ak",
  AutoConversionPage = "acp",
  BankDetails = "bd",
  CallbackPayoutURL = "cbp",
  DomainPage = "dp",
  SecurityPage = "sp",
  Team = "tp",
}
const items: TabsProps["items"] = [
  {
    children: <SettingsBankDetailsPage />,
    key: SettingTab.BankDetails,
    label: `Bank Details`,
  },
  {
    children: <SettingsSecurityPage />,
    key: SettingTab.SecurityPage,
    label: `Security`,
  },
  {
    children: <SettingsApiKeysPage />,
    key: SettingTab.ApiKeys,
    label: `API Keys`,
  },
  {
    children: <SettingsAllowlistPage />,
    key: SettingTab.AllowListPage,
    label: `Allow List`,
  },
  {
    children: <SettingsAutoConversionPage />,
    key: SettingTab.AutoConversionPage,
    label: `Auto Conversion`,
    visible: !UiStore().isTransferioTheme,
  },
  {
    children: <SettingsCallbackUrlPage />,
    key: SettingTab.CallbackPayoutURL,
    label: `Callback Payout URL`,
  },
  {
    children: <SettingsTeam />,
    key: SettingTab.Team,
    label: `Team`,
  },
]
  .filter(({ visible }) => (visible !== undefined ? Boolean(visible) : true))
  .map((c) => ({ children: c.children, key: c.key, label: c.label }))

const SettingsTabQuery = "tab"

export const SettingsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const currentTab = searchParams.get(SettingsTabQuery) as SettingTab

  useEffect(() => {
    if (!currentTab) {
      setSearchParams({ [SettingsTabQuery]: SettingTab.BankDetails })
    }
  }, [currentTab])

  return (
    <DefaultPageLayout title="Settings">
      <Tabs
        activeKey={currentTab}
        className={css.tabs}
        items={items}
        onChange={(key) => setSearchParams({ [SettingsTabQuery]: key })}
      />
    </DefaultPageLayout>
  )
}
